import { Form, Select, type SelectProps } from "antd";
import { useMemo } from "react";
import { type Rule } from "antd/es/form";
import { type FilterFunc } from "rc-select/lib/Select";
import { type DefaultOptionType } from "antd/es/cascader";
import { type Location } from "../../generated-axios-client";
import type { IntlShape } from "@formatjs/intl";

const locationSelectOptions = (locationItems: Location[]) =>
	locationItems.map((item) => ({
		key: item.id,
		value: item.id,
		label: item.name,
	}));

const locationSearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
	const search = input.toLowerCase();
	const value = option?.label?.toString().toLowerCase?.() ?? "";
	return value.includes(search);
};

type LocationSelectFormItemProps = {
	intl: IntlShape;
	locationItems?: Location[];
	rules?: Rule[];
	placeholder?: string | boolean;
	selectProps?: SelectProps<string>;
};

export const LocationSelectorFormItem = (props: LocationSelectFormItemProps) => {
	const { intl, locationItems, rules = [], placeholder = false, selectProps } = props;

	const options = useMemo(() => locationSelectOptions(locationItems ?? []), [locationItems]);

	return (
		<Form.Item
			name="location"
			label={intl.formatMessage({ id: "turbine_location" })}
			rules={rules}
		>
			<Select
				placeholder={placeholder}
				showSearch={true}
				options={options}
				filterOption={locationSearchHandler}
				{...selectProps}
			/>
		</Form.Item>
	);
};
